<template>
	<div class="container bg_main">

		<div class="fullwidth padding15">

			<div class="bg_fff radius10 padding15">
				

					
					<div class="">
						<div class="middle uni-icon uni-icon-info-filled color_blue"></div><span class="marginl5 color_blue">送至</span>
						<div class=" ">{{detail.contactModel.area}} {{detail.contactModel.address}}</div>
					</div>
					
					<div class="margint15">
						<div class="middle uni-icon uni-icon-info-filled color_blue"></div><span class="marginl5 color_blue">运费</span>
						<div class=" ">{{detail.orderPeisongEntity.amount}}</div>
					</div>

					<div class="margint15">
						<div class="middle uni-icon uni-icon-info-filled color_blue"></div><span class="marginl5 color_blue">收货人</span>
						<div class=" ">{{detail.contactModel.contacter}}</div>
					</div>
					
					<div class="margint15">
						<div class="middle uni-icon uni-icon-info-filled color_blue"></div><span class="marginl5 color_blue">手机</span>
						<div class=" ">{{detail.contactModel.phone}}</div>
					</div>
					
					<div class="margint15">
						<div class="middle uni-icon uni-icon-info-filled color_blue"></div><span class="marginl5 color_blue">取自</span>
						<div class=" ">{{shop.address}}</div>
					</div>


					<div class="fixed bottom0 padding10 h5maxwidth left0 right0 automargin fullwidth">
						<div class="flex_row padding0  automargin ">
							<div @click="toExit" class=" flex1 bg_fff center radiusl20 size4 lineh1 padding15">取消</div>
							<div @click="acceptPeisong"
								class="flex1 radiusr20 center radius20 size4 bg_red color5 margin0 lineh1 padding15">我要接单
							</div>
						</div>
					</div>
			

			</div>
		</div>

	</div>
</template>

<script>

	// import mypopUnslider from '@/components/mypop-unslider/mypop-unslider.vue';
	// var app = getApp();

	export default {
		components: {
			// mypopUnslider
		},
		data() {
			return {
				user: {},
				detail: {contactModel:{},orderPeisongEntity:{}},
				id:"",//订单ID
				shop:{},
				
			};
		},
		created() {
			
			var options=this.$route.query || {};
			console.log(options);
			if (options && !!options.id == true) {
				this.id = options.id;
			}


			this.user = window.$utils.uniapi.getStorageSync("user") || {};
			this.shop = window.$utils.uniapi.getStorageSync("selectedShop") || {};

			

		},
		mounted() {

			//this.$refs.selectarea_pop.close();
			this.getOrderDetail();
		},

		onPullDownRefresh() {
			this.getOrderDetail();
		},
		onReachBottom() {
			
		},
		methods: {

			/**
			 * 接单
			 */
			acceptPeisong(){
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined") {
					alert( '请先登录' );
					this.$router.push({ path: "/user_login" });
					return false;
				}
				var params = {
					id: this.id,
				};
				this.$axios.request({
						url: window.$config.url.acceptPeisong,
						data: params
					})
					.then(res => {
						// uni.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							alert(res.msg);
						}else{
							alert(res.msg);
						}
					});
			},

			getOrderDetail() {
				console.log("getDetail");
				var that = this;
				if ((!!this.id == false || typeof this.id == "undefined")
					&& (!!this.payId == false || typeof this.payId == "undefined")
					){
					alert("没有ID");
					return;
				}
				//时间控制
				var currtime = new Date().getTime();
				if (currtime < this.lastGetOrderDetailTime + 1000) {
					return;
				}
				this.lastGetOrderDetailTime = currtime;

				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined") {
					alert( '请先登录' );
					this.$router.push({ path: "/user_login" });
					return false;
				}
				var params = {
					id: this.id,
					isQueryContact: 1, isQueryPeisong: 1,
					payId: this.payId
				};
				this.$axios.request({
						url: window.$config.url.getOrderDetail,
						data: params
					})
					.then(res => {
						// uni.stopPullDownRefresh();
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							var d = res.data;
							that.detail = d;
						}
					});
			},



			toExit() {
				this.$router.push({ path: "/" });
				
			},
			

		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.uni-media-list-logo {
		width: 90px;
		height: 70px;
	}

	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		height: 37px;
		font-size: 14px;
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/peisong_accept.vue